var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 546.9 547",
    style: {
      enableBackground: "new 0 0 546.9 547"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.7,137.6C189.6,148.8,184,162.2,184,178v312c0,15.8,5.6,29.2,16.7,40.3c11.1,11.1,24.6,16.7,40.3,16.7 h248.9c15.8,0,29.2-5.6,40.3-16.7c11.1-11.1,16.7-24.5,16.7-40.3V178c0-15.8-5.6-29.2-16.7-40.4c-11.1-11.1-24.5-16.6-40.3-16.6 H241C225.2,121,211.8,126.6,200.7,137.6 M233.2,170.2c2.2-2.1,4.8-3.2,7.8-3.2h248.9c3,0,5.6,1.1,7.8,3.2 c2.2,2.2,3.3,4.8,3.2,7.8v312c0,3-1.1,5.6-3.2,7.8c-2.1,2.2-4.7,3.3-7.8,3.2H241c-3,0-5.6-1.1-7.8-3.2c-2.1-2.1-3.2-4.7-3.2-7.8 V178C230,175,231.1,172.4,233.2,170.2 M276.2,350.2c4.5,4.5,9.9,6.8,16.3,6.8h50v50c0,6.4,2.2,11.8,6.7,16.2 c4.5,4.5,9.9,6.8,16.3,6.8c6.4,0,11.8-2.2,16.2-6.8c4.5-4.5,6.8-9.9,6.8-16.2v-50h50c6.4,0,11.8-2.2,16.2-6.8 c4.5-4.5,6.8-9.9,6.8-16.2c0-6.4-2.2-11.8-6.8-16.3c-4.5-4.5-9.9-6.7-16.2-6.7h-50v-50c0-6.4-2.2-11.8-6.8-16.3 c-4.5-4.5-9.9-6.7-16.2-6.7c-6.4,0-11.8,2.2-16.3,6.7c-4.5,4.5-6.7,9.9-6.7,16.3v50h-50c-6.4,0-11.8,2.2-16.3,6.7 c-4.5,4.5-6.7,9.9-6.7,16.3C269.4,340.4,271.7,345.8,276.2,350.2 M362.9,57c0-15.8-5.5-29.2-16.6-40.3C335.2,5.6,321.7,0,306,0 H57C41.2,0,27.8,5.6,16.7,16.7C5.6,27.8,0,41.2,0,57v312c0,15.8,5.6,29.2,16.7,40.3C27.8,420.5,41.2,426,57,426h78v-46H57 c-3,0-5.6-1.1-7.8-3.2c-2.2-2.2-3.2-4.8-3.2-7.8V57c0-3,1.1-5.6,3.2-7.8C51.4,47.1,54,46,57,46h249c3,0,5.6,1.1,7.8,3.2 c2.1,2.1,3.2,4.7,3.2,7.8v18h46V57z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate_icon.07fb2178.svg";
export { ForwardRef as ReactComponent };